import React, { useEffect, useState } from 'react';
import { Label, Option, Select } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import { StyledLabelContainer } from './OrganisationEditorModal';
import { useGetAllTenants } from '../../apollo/queries/getAllTenants.queries';

interface Props {
  selectedTenantCode: string;
  width?: string;
  onChange: (tenantCode: string) => void;
}

const StyledContainer = styled.div<{ width: string }>`
  display: flex;
  width: ${({ width }) => width};
  flex-direction: column;
`;

const TenantDropdown = ({
  selectedTenantCode,
  onChange,
  width = '100%',
}: Props) => {
  const [tenantCode, setTenantCode] = useState<string>(selectedTenantCode);
  const { tenants } = useGetAllTenants();

  useEffect(() => {
    setTenantCode(selectedTenantCode);
  }, [selectedTenantCode]);

  return (
    <StyledContainer width={width}>
      <StyledLabelContainer>
        <Label title="Tenant" />
      </StyledLabelContainer>
      <Select
        searchable
        data-testid="select-tenant"
        selectedOption={tenantCode}
        onSelectChange={(_id, name) => {
          onChange(name);
        }}
        placeholder="Select Tenant"
      >
        {tenants.map((tenant) => (
          <Option key={tenant}>{tenant}</Option>
        ))}
      </Select>
    </StyledContainer>
  );
};

export default TenantDropdown;
